<template>
  <div id="auth" class="text-center">
    <amplify-authenticator v-bind:authConfig="authConfig"></amplify-authenticator>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      authConfig: {},
      signOutConfig: {}
    };
  }
};
</script>

<style>
#auth {
  margin-top: 40px;
}

div.Form__formSection___3tqxz {
  min-width: 560px;
}
</style>